import axios from 'axios'
import config from '../../../config'
import wrapper from 'axios-cache-plugin'

let cacheCard = wrapper(axios, {
  maxCacheSize: Infinity
});

cacheCard.__addFilter(/blood-glucose/)

let BloodGlucoseApi = {

  /**
   * Gets users total range count
   * @param fromDate
   * @param toDate
   * @returns {AxiosPromise}
   */
  getBloodGlucoseRanges(fromDate, toDate) {
    return axios.get(config.apiUrl + 'tracking/blood-glucose/ranges/?fromDate=' + fromDate + '&toDate' + toDate)
  },
  /**
   * @param id
   */
  deleteGlucoseReading(progressId, trackingId) {
    return axios.delete(config.apiUrl + 'tracking/blood-glucose/', {
      params: {
        progressId: progressId,
        trackingId: trackingId
      }
    })
  },
  /**
   *
   * @param page
   * @param page_size
   * @returns {AxiosPromise}
   */
  getBloodGlucoseTrackingDetail(page, page_size) {
    return axios.get(config.apiUrl + 'tracking/blood-glucose/detail/', {
      params: {
        page: page,
        page_size: page_size
      }
    })
  },

  /**
   *
   * @returns {AxiosPromise}
   */
  getBloodGlucoseTrackingCard() {
    return cacheCard({
      method: "GET",
      url: config.apiUrl + 'tracking/blood-glucose/card/?requestFrom=web',
    });
  },
  updateBloodGlucoseTracking(model) {
    return axios.put(config.apiUrl + 'tracking/blood-glucose/', model)
  },
  /**
   * @param model
   * @returns {AxiosPromise}
   */
  postBloodGlucoseTracking(model) {
    return axios.post(config.apiUrl + 'tracking/blood-glucose/', model);
  }
};

export default BloodGlucoseApi



// WEBPACK FOOTER //
// ./src/api/Tracking/BloodGlucose/index.js